import { useEffect, useState } from 'react';

export function useElementWidth() {
    const [element, setElement] = useState<HTMLElement | null>(null);
    const [width, setWidth] = useState(0);

    useEffect(() => {
        if (!element) {
            setWidth(0);

            return;
        }

        const resizeObserver = new ResizeObserver((entries) => {
            const entry = entries.find((entry) => entry.target === element);
            const currentWidth = entry?.contentRect.width || 0;

            // Асинхронная установка ширины здесь делается для того, чтобы избежать "ResizeObserver loop"
            setTimeout(() => setWidth(currentWidth), 0);
        });

        resizeObserver.observe(element);

        return () => resizeObserver.disconnect();
    }, [element]);

    return [setElement, width] as const;
}
